import React, { useEffect, useRef, useState } from "react";
import CamWarningCard from "../warningCards/CamWarningCard";
import NoiseWarningCard from "../warningCards/NoiseWarningCard";
import MultiFaceWarning from "../warningCards/multiFaceWarningCard";

//style
import "./warningContainer.scss";

const WarningContainer = () => {
  return (
    <div className="warnings mt-4">
      <CamWarningCard />
      <NoiseWarningCard />
      <MultiFaceWarning />
    </div>
  );
};

export default WarningContainer;
